// extracted by mini-css-extract-plugin
export default {"news":"Main_news__wZTp9","news__list":"Main_news__list__e1-Tt","news__empty":"Main_news__empty__F+dhX"};